export default "__VITE_ASSET__zufqYlH9__"